module.exports = __webpack_public_path__ + "img/computer_seo.96eff1c5.svg";